import React, {useContext} from 'react'
import styled from 'styled-components'

import { StateContext } from '../../utils/context'

export default ({isTop}) => {
  const { state, dispatch } = useContext(StateContext)
  return (
    <Container 
      onClick={() => dispatch({type: 'HeaderMenuActive', payload: !state.isHeaderMenuActive})} 
      isTop={isTop}
      isActive={state.isHeaderMenuActive}
    >
      <TopBar className={state.isHeaderMenuActive ? 'active' : null}/>
      <MidBar className={state.isHeaderMenuActive ? 'active' : null}/>
      <BotBar className={state.isHeaderMenuActive ? 'active' : null}/>
    </Container>
  )
}

const Container = styled.button`
  justify-self: flex-end;
  width: 50px;
  height: 50px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${props => props.isActive ? props.theme.green : props.isTop ? props.theme.green : 'transparent'};
  border: none;
  ${props => props.isActive ? null : props.isTop ? null : `border: 1px solid ${props.theme.white}`};
  border-radius: 50%;
  z-index: 9999;
  @media(min-width: 900px) {
    display: none;
  }
`
const BarBasic = styled.div`
  width: 26px;
  height: 3px;
  background-color: #fff;
  transition: all 0.3s;
  border-radius: 50px;
  padding: 0;
  margin: 0;
`
const TopBar = styled(BarBasic)`
  position: relative;
  &.active {
    transform: rotate(-45deg) translate(-5px, 5px);
  }
`
const MidBar = styled(BarBasic)`
  margin-top: 4px;
  margin-bottom: 4px;
  &.active {
    background-color: transparent;
  }
`
const BotBar = styled(BarBasic)`
  position: relative;
  &.active {
    transform: rotate(45deg) translate(-5px, -5px);
  }
`